import React from "react";
import theme from "theme";
import { Theme, Link, Text, Hr, Input, Structure, Button, Section } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"whats-smoking"} />
		<Helmet>
			<title>
				Commando BBQ
			</title>
			<meta name={"description"} content={"Experimenting with Food and Fire, Sharing Life with Friends"} />
			<meta property={"og:title"} content={"Commando BBQ"} />
			<meta property={"og:description"} content={"Experimenting with Food and Fire, Sharing Life with Friends"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/68ac60ec90a2bb0024b83282/images/Pig-Crossbones-red-domainame.png?v=2025-08-25T13:11:45.249Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/68ac60ec90a2bb0024b83282/images/Pig-Crossbones-red-large%20%281%29.png?v=2025-08-25T15:28:19.612Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/68ac60ec90a2bb0024b83282/images/Pig-Crossbones-red-large%20%281%29.png?v=2025-08-25T15:28:19.612Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/68ac60ec90a2bb0024b83282/images/Pig-Crossbones-red-large%20%281%29.png?v=2025-08-25T15:28:19.612Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/68ac60ec90a2bb0024b83282/images/Pig-Crossbones-red-large%20%281%29.png?v=2025-08-25T15:28:19.612Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/68ac60ec90a2bb0024b83282/images/Pig-Crossbones-red-large%20%281%29.png?v=2025-08-25T15:28:19.612Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/68ac60ec90a2bb0024b83282/images/Pig-Crossbones-red-large%20%281%29.png?v=2025-08-25T15:28:19.612Z"} />
			<meta name={"msapplication-TileColor"} content={"#232323"} />
		</Helmet>
		<Components.SiteHeader>
			<Override slot="linkBox" href="/index" />
			<Text
				margin="0px 0px 0px 0px"
				font="--headline1"
				color="--light"
				text-align="center"
				align-self="center"
				flex="1 1 0%"
			>
				What's Smoking?
			</Text>
		</Components.SiteHeader>
		<Section>
			<Text margin="0px 0px 0px 0px" font="--headline1" color="--light" text-align="center">
				Labor Day Weekend 2025
			</Text>
			<Text
				margin="0px 0px 0px 0px"
				font="--headline2"
				color="#8e3d3d"
				text-align="center"
				text-shadow="2px 1px 2px #ffffff"
			>
				Kickoff for College Football
			</Text>
			<Text margin="0px 0px 0px 0px" font="--lead" color="--lightD1" text-align="center">
				I am firing up the smoker and cooking for friends!
				<br />
				Please use this form to let me know what you want.{" "}
				<br />
				I will follow up with you to confirm your order.
			</Text>
			<Text
				margin="0px 0px 0px 0px"
				font="--base"
				color="--lightD1"
				text-align="left"
				padding="10px 0px 10px 0px"
			>
				(Note: I am only cooking for personal friends, so if you've stumbled across this hidden page on the internet please ignore it and move along.)
			</Text>
			<Hr min-height="10px" min-width="100%" margin="0px 0px 0px 0px" />
			<Components.QuarklycommunityKitNetlifyForm formName="CookingEvent">
				<Text margin="0px 0px 0px 0px" font="--lead" color="--lightD1" text-align="left">
					Your Details:
				</Text>
				<Structure>
					<Override slot="Content">
						<Override slot="cell-0">
							<Input
								display="block"
								placeholder-color="LightGray"
								background="white"
								name="CustomerName"
								type="text"
								placeholder="Your Name"
								required
								width="100%"
							/>
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light">
								Name
							</Text>
						</Override>
						<Override slot="cell-1">
							<Input
								display="block"
								placeholder-color="LightGray"
								background="white"
								name="Customer Email"
								type="email"
								placeholder="Your Email"
								required
								width="100%"
							/>
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light">
								Email
							</Text>
						</Override>
						<Override slot="cell-2">
							<Input
								display="block"
								placeholder-color="LightGray"
								background="white"
								name="CustomerPhone"
								type="tel"
								placeholder="Your Phone"
								required
								width="100%"
							/>
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light">
								Phone
							</Text>
						</Override>
					</Override>
				</Structure>
				<Text margin="0px 0px 0px 0px" font="--lead" color="--lightD1" text-align="left">
					Your Order:
				</Text>
				<Text
					margin="0px 0px 0px 0px"
					font="--base"
					color="--lightD1"
					text-align="left"
					padding="10px 0px 10px 0px"
				>
					NOTE: For this weekend, I will be cooking on Friday, so you will need to reheat it if you're planning your meal on a different day.
					<br />
					The meats will be in either plastic pint containers or small aluminum pans, depending on the quantity. I'm not planning to use the vacuum sealed bags for this event.
				</Text>
				<Structure>
					<Override slot="Content">
						<Override slot="cell-0">
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light">
								Pulled Pork (pounds)
							</Text>
							<Text margin="0px 0px 0px 0px" font="--base" color="--light">
								1 Pound = 4 Servings
							</Text>
						</Override>
						<Override slot="cell-1">
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light" text-align="center">
								$10 / pound
							</Text>
						</Override>
						<Override slot="Cell 0th" />
						<Override slot="cell-2">
							<Input
								display="block"
								placeholder-color="LightGray"
								background="white"
								name="PorkQty"
								type="number"
								defaultValue="0"
								width="80px"
								height="30px"
							/>
							<Text margin="0px 0px 0px 0px" font="--base" color="--light">
								Quantity (pounds)
							</Text>
						</Override>
					</Override>
				</Structure>
				<Structure>
					<Override slot="Content">
						<Override slot="cell-0">
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light">
								Pulled Chicken (pounds)
							</Text>
							<Text margin="0px 0px 0px 0px" font="--base" color="--light">
								1 Pound = 4 Servings
							</Text>
						</Override>
						<Override slot="cell-1">
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light" text-align="center">
								$10 / pound
							</Text>
						</Override>
						<Override slot="Cell 0th" />
						<Override slot="cell-2">
							<Input
								display="block"
								placeholder-color="LightGray"
								background="white"
								name="ChickenQty"
								type="number"
								defaultValue="0"
								width="80px"
								height="30px"
							/>
							<Text margin="0px 0px 0px 0px" font="--base" color="--light">
								Quantity (pounds)
							</Text>
						</Override>
					</Override>
				</Structure>
				<Structure>
					<Override slot="Content">
						<Override slot="cell-0">
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light">
								Smoked Beans (pints)
							</Text>
							<Text margin="0px 0px 0px 0px" font="--base" color="--light">
								1 Pint = 4-6 Servings
							</Text>
						</Override>
						<Override slot="cell-1">
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light" text-align="center">
								$6 / pint
							</Text>
						</Override>
						<Override slot="Cell 0th" />
						<Override slot="cell-2">
							<Input
								display="block"
								placeholder-color="LightGray"
								background="white"
								name="BeanQty"
								type="number"
								defaultValue="0"
								width="80px"
								height="30px"
							/>
							<Text margin="0px 0px 0px 0px" font="--base" color="--light">
								Quantity (pints)
							</Text>
						</Override>
					</Override>
				</Structure>
				<Text margin="0px 0px 0px 0px" font="--base" color="--light" padding="0px 0 0px 60px">
					Note: The Smoked Beans are mildly spicy due to the sauce that I use. Please let me know in the Comments if you would prefer No Heat.
				</Text>
				<Structure>
					<Override slot="Content">
						<Override slot="cell-0">
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light">
								Mac & Cheese (small pan)
							</Text>
							<Text margin="0px 0px 0px 0px" font="--base" color="--light">
								Serves 4 large portions, or 6-8 small portions
							</Text>
						</Override>
						<Override slot="cell-1">
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light" text-align="center">
								$12 / pan
							</Text>
						</Override>
						<Override slot="Cell 0th" />
						<Override slot="cell-2">
							<Input
								display="block"
								placeholder-color="LightGray"
								background="white"
								name="MacCheeseSmall"
								type="number"
								defaultValue="0"
								width="80px"
								height="30px"
							/>
							<Text margin="0px 0px 0px 0px" font="--base" color="--light">
								Quantity (small pans)
							</Text>
						</Override>
					</Override>
				</Structure>
				<Structure>
					<Override slot="Content">
						<Override slot="cell-0">
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light">
								Mac & Cheese (large pan)
							</Text>
							<Text margin="0px 0px 0px 0px" font="--base" color="--light">
								Serves 15-20 portions
							</Text>
						</Override>
						<Override slot="cell-1">
							<Text margin="0px 0px 0px 0px" font="--lead" color="--light" text-align="center">
								$24 / pan
							</Text>
						</Override>
						<Override slot="Cell 0th" />
						<Override slot="cell-2">
							<Input
								display="block"
								placeholder-color="LightGray"
								background="white"
								name="MacCheeseLarge"
								type="number"
								defaultValue="0"
								width="80px"
								height="30px"
							/>
							<Text margin="0px 0px 0px 0px" font="--base" color="--light">
								Quantity (large pans)
							</Text>
						</Override>
					</Override>
				</Structure>
				<Text margin="0px 0px 0px 0px" font="--lead" color="--light">
					Comments / Requests:
				</Text>
				<Input
					display="block"
					placeholder-color="LightGray"
					background="white"
					as="textarea"
					name="Comments"
					width="80%"
					type="text"
				/>
				<Button margin="20px 0px 0px 0">
					SUBMIT
				</Button>
			</Components.QuarklycommunityKitNetlifyForm>
		</Section>
		<Components.QuarklycommunityKitNetlifyForm />
		<Link
			font={"--capture"}
			font-size={"10px"}
			position={"fixed"}
			bottom={"12px"}
			right={"12px"}
			z-index={"4"}
			border-radius={"4px"}
			padding={"5px 12px 4px"}
			background-color={"--dark"}
			opacity={"0.6"}
			hover-opacity={"1"}
			color={"--light"}
			cursor={"pointer"}
			transition={"--opacityOut"}
			quarkly-title={"Badge"}
			text-decoration-line={"initial"}
			href={"https://quarkly.io/"}
			target={"_blank"}
		>
			Made on Quarkly
		</Link>
		<RawHtml>
			<style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});